import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Tree } from 'primeng/tree';
import { ProductsService } from 'src/app/shared/services/products.service';


@Component({
  selector: 'app-products-lists',
  templateUrl: './products-lists.component.html',
  styleUrls: ['./products-lists.component.scss']
})
export class ProductsListsComponent implements OnInit, OnChanges {

  @Input() kind: string; 

  @Input() selectedCategory: any;
  @Output() selectedCategoryChange = new EventEmitter<any>();

  @Input() selectedType: any;
  @Output() selectedTypeChange = new EventEmitter<any>();

  @Input() selectedItem: any;
  @Output() selectedItemChange = new EventEmitter<any>();

  @Input() selectedProductId: any;
  @Output() selectedProductIdChange = new EventEmitter<any>();

  @Output() selectionChanged = new EventEmitter<any>();

  categoriesByKind: any[] = [];
  typesByCategory: any[] = [];
  itemsByType: any[] = [];

  constructor(private productsService: ProductsService) { }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedCategory'] && !changes['selectedCategory'].firstChange) {
      this.onCategoryChange(true); // Call category change logic if a new category is provided    
    }
    if (changes['selectedType'] && !changes['selectedType'].firstChange) {
      this.onTypeChange(true); // Call type change logic if a new type is provided 
    }
  }

  ngOnInit(): void {
    if (this.kind) {
      this.loadCategoriesByKind();
    }
  }

  loadCategoriesByKind() {
    this.productsService.getProductsByKind(this.kind).subscribe(data => {
      this.categoriesByKind = this.transformCategories(data);

      // If a category, type, or item was pre-selected, filter the dropdowns
      if (this.selectedCategory) {
        this.onCategoryChange(true);
      }
      if (this.selectedType) {
        this.onTypeChange(true);
      }
    });
  }

  // Transform categories into a grouped structure
  transformCategories(data: any): any[] {
    const licenseTypes = [];
    const serviceTypes = [];
    const categoryMap = {};

    Object.keys(data).forEach(kind => {
      Object.keys(data[kind]).forEach(categoryName => {
        const types = [];
        Object.keys(data[kind][categoryName]).forEach(typeName => {
          types.push({
            productType: typeName,
            items: data[kind][categoryName][typeName]
          });
        });

        if (!categoryMap[categoryName]) {
          categoryMap[categoryName] = { category: categoryName, types };
        } else {
          categoryMap[categoryName].types.push(...types);
        }
      });
    });

    Object.keys(categoryMap).forEach(categoryName => {
      const category = categoryMap[categoryName];
      if (categoryName.toLowerCase() === 'service') {
        serviceTypes.push({ label: category.category, value: category });
      } else {
        licenseTypes.push({ label: category.category, value: category });
      }
    });

    return [
      { label: 'License Categories', items: licenseTypes },
      { label: 'Service Categories', items: serviceTypes }
    ];
  }

  // When category is changed
  onCategoryChange(initialLoad = false) {

    this.typesByCategory = this.selectedCategory ? this.selectedCategory.types : [];
    this.itemsByType = []; // Reset items when category changes
    if (!initialLoad) {
      this.selectedType = null;
      this.selectedItem = null;
      this.selectedProductId = null;
    }

    // Emit changes for two-way binding
    this.selectedCategoryChange.emit(this.selectedCategory);
    this.selectedTypeChange.emit(this.selectedType);
    this.selectedItemChange.emit(this.selectedItem);
    this.selectedProductIdChange.emit(this.selectedProductId);
  }

  // When type is changed
  onTypeChange(initialLoad = false) {
    this.itemsByType = this.selectedType ? this.selectedType.items : [];
    if (!initialLoad) {
      this.selectedItem = null;
      this.selectedProductId = null;
    }

    // Emit changes for two-way binding
    this.selectedTypeChange.emit(this.selectedType);
    this.selectedItemChange.emit(this.selectedItem);
    this.selectedProductIdChange.emit(this.selectedProductId);
  }

  // When item is selected
  onItemChange() {
    this.selectedProductId = this.selectedItem?.productId;

    // Emit changes for two-way binding
    this.selectedItemChange.emit(this.selectedItem);
    this.selectedProductIdChange.emit(this.selectedProductId);

    // Emit selectionChanged event with full details
    this.selectionChanged.emit({
      category: this.selectedCategory,
      type: this.selectedType,
      item: this.selectedItem,
      selectedProductId: this.selectedProductId
    });
  }
}
